import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import createSagaMiddleware from 'redux-saga'

import api from '@/core/api'
import { dmpConnectJS2Api } from '@/core/api/dmp-connect-js2'
import { tutorialsApi } from '@/core/api/tutorials'

import { addDictaphoneDocument, addDocument } from './reducers/document.reducer'
import { login as loginWithRocketChat } from './reducers/rocket-chat.reducer'

import rootReducer from './rootReducer'
import type { RootState } from './rootReducer'
import rootSaga from './rootSaga'

const sagaMiddleware = createSagaMiddleware()

export default function configureAppStore(initialState = {} as RootState) {
  const store = configureStore<RootState>({
    reducer: rootReducer(initialState),
    // TODO: type check for middleware
    // @ts-ignore
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, addDocument.type, loginWithRocketChat.type, addDictaphoneDocument.type],
        },
      }).concat(sagaMiddleware, api.middleware, dmpConnectJS2Api.middleware, tutorialsApi.middleware),
    preloadedState: initialState,
    devTools: import.meta.env.NODE_ENV !== 'production',
  })

  setupListeners(store.dispatch)
  sagaMiddleware.run(rootSaga)

  const persistor = persistStore(store)
  return { store, persistor }
}
